import { render } from "./Vaga.vue?vue&type=template&id=3cb6c9b9&scoped=true"
import script from "./Vaga.vue?vue&type=script&lang=js"
export * from "./Vaga.vue?vue&type=script&lang=js"

import "./Vaga.vue?vue&type=style&index=0&id=3cb6c9b9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3cb6c9b9"

export default script